import type { LodasPersonData } from '../../server/lodas/LodasPersonData.js';

export function generateKostenStellen(satzNummer: string, persons: LodasPersonData[]) {
  const mappedLine: string[] = [];

  for (const person of persons) {
    if (!person.kostenStelle.length || !person.kostenStelle.length) continue;
    for (let i = 0; i < person.kostenStelle.length; i++) {
      mappedLine.push(
        `${satzNummer};"${person.personalNr}";"${person.lodasPersonalNr}";${person.kostenStelle.at(i) ?? ''};${
          person.kostenStelleProzent.at(i) ?? ''
        };`,
      );
    }
  }

  return mappedLine.join('\r\n');
}
